import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Leaf, Gift, Droplets } from 'lucide-react';
export function BenefitsSection() {
  const benefits = [{
    icon: <BookOpen className="w-10 h-10 text-artisanal-sage" data-id="element-11" />,
    title: 'Aprende paso a paso',
    desc: 'Domina la elaboración de velas y jabones artesanales desde cero, sin complicaciones.'
  }, {
    icon: <Droplets className="w-10 h-10 text-artisanal-sage" data-id="element-12" />,
    title: 'Habilidad terapéutica',
    desc: 'Desarrolla una práctica creativa que te ayuda a relajar la mente y reducir la ansiedad.'
  }, {
    icon: <Gift className="w-10 h-10 text-artisanal-sage" data-id="element-13" />,
    title: 'Crea y personaliza',
    desc: 'Diseña productos únicos para tu uso personal, regalos inolvidables o para iniciar tu venta.'
  }, {
    icon: <Leaf className="w-10 h-10 text-artisanal-sage" data-id="element-14" />,
    title: 'Conexión natural',
    desc: 'Trabaja con procesos manuales y materiales naturales, respetuosos contigo y el medio ambiente.'
  }];
  return <section className="py-20 bg-artisanal-beige" data-id="element-15">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-16">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-17">
          <h2 className="font-serif text-3xl md:text-4xl text-artisanal-brown font-bold mb-4" data-id="element-18">
            Lo que lograrás con este arte
          </h2>
          <div className="w-24 h-1 bg-artisanal-terracotta mx-auto rounded-full" data-id="element-19"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12" data-id="element-20">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: index % 2 === 0 ? -20 : 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex items-start space-x-6 bg-white p-8 rounded-2xl shadow-sm hover:shadow-md transition-shadow" data-id="element-21">
              <div className="flex-shrink-0 bg-artisanal-sage/10 p-4 rounded-full" data-id="element-22">
                {benefit.icon}
              </div>
              <div data-id="element-23">
                <h3 className="font-serif text-xl font-bold text-artisanal-brown mb-2" data-id="element-24">
                  {benefit.title}
                </h3>
                <p className="font-sans text-artisanal-brown/70 leading-relaxed" data-id="element-25">
                  {benefit.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}